import {
  Box,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  useEventCallback,
} from "@mui/material";

import HistoryIcon from "@mui/icons-material/History";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiCall } from "../../../API/apiCall";
import useDebounce from "../../../helper/debounce";
import GenericTable from "../../common/MUIDataTable";

const headerCellSx = {
  backgroundColor: "#6a3fc9",
  color: "white",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 3,
};

// const columns = [
//   {
//     id: "sno",
//     label: "S.No",
//     align: "left",
//   },
//   {
//     id: "email",
//     label: "Email",
//     align: "left",
//   },
//   {
//     id: "name",
//     label: "Name",
//     align: "left",
//   },
//   {
//     id: "organization",
//     label: "Organization",
//     align: "left",
//   },
//   {
//     id: "role",
//     label: "Role",
//     align: "left",
//   },
//   {
//     id: "actions",
//     label: "Actions",
//     align: "right",
//   },
// ];

const PortalUsageReport = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [alignment, setAlignment] = useState("fee-based");
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const limit = 5;

  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);

  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search.trim(), 1000);

  const handleToggleChange = useEventCallback((event, newAlignment) => {
    if (newAlignment !== null) {
      handlePageChange(1);
      setAlignment(newAlignment);
    }
  }, []);

  useEffect(() => {
    setPage(1);
  }, [alignment, debounceValue]);

  useEffect(() => {
    (async function () {
      try {
        setIsLoading(true);
        const response = await apiCall({
          url: "sessions-reports/users",
          method: "GET",
          params: {
            limit: limit,
            page: page,
            planType: alignment,
            searchValue: debounceValue,
            searchFields: "Email,instituteName,Fname,Lname",
          },
        });

        if (response?.status === "success") {
          setUsers(response.results);
          setPagination(response.pagination);
        }
      } catch (error) {
        console.log("Error : ", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [alignment, debounceValue, page]);

  const handleViewUserActive = (id) => {
    navigate(`/admin/portal-usage-report/user-activity/${id}?page=1`);
  };

  const handlePageChange = (value) => {
    setPage(value);
    setSearchParams(
      (prev) => {
        prev.set("page", Number(value));
        return prev;
      },
      { replace: true }
    );
  };

  const handleSearchInputChange = (e) => {
    setSearch(e.target.value);
  };

  const userColumns = [
    {
      id: "sno",
      label: "S.No",
      render: (_, index) => index + 1,
    },
    {
      id: "Email",
      label: "Email",
    },
    {
      id: "name",
      label: "Name",
      render: (row) =>
        row.Fname ? `${row.Fname} ${row.Lname}` : row.instituteName,
    },
    {
      id: "instituteName",
      label: "Institute",
    },
    {
      id: "userType",
      label: "Type",
    },
    {
      id: "actions",
      label: "Actions",
      align: "right",
      render: (row) => (
        <Tooltip title="View User Activity" arrow>
          <Button
            variant="contained"
            size="small"
            sx={{
              minWidth: "40px",
              backgroundColor: "#6e3fc9",
              "&:hover": { backgroundColor: "#5a32a3" },
            }}
            onClick={() => handleViewUserActive(row._id)}
          >
            <HistoryIcon fontSize="small" />
          </Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <section>
        <div className="container">
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              color: "#6e3fc9",
              borderColor: "#6e3fc9",
              textTransform: "uppercase",
              fontWeight: "bold",
              letterSpacing: "1px",
              "&:hover": {
                backgroundColor: "#f2ecfc",
                borderColor: "#4a2b8a",
                color: "#4a2b8a",
              },
            }}
          >
            Go Back
          </Button>
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12 col-md-12 col-12">
              <div className="mid_banner">
                <h2>
                  Portal Usage <span>Report</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="table_section py-5">
        <div className="container">
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { sm: "center" },
              justifyContent: "flex-end",
              gap: 1,
              mb: 2,
            }}
          >
            <TextField
              label="Search"
              variant="outlined"
              onChange={handleSearchInputChange}
              sx={{
                "& .MuiInputLabel-root": {
                  color: "#6e3fc9",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#6e3fc9" },
                  "&:hover fieldset": { borderColor: "#4a2b8a" },
                  "&.Mui-focused fieldset": { borderColor: "#4a2b8a" },
                  "&.Mui-focused": { backgroundColor: "#f2ecfc" },
                },
              }}
            />
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleToggleChange}
              aria-label="Institute management toggle"
              sx={{
                mb: 2,
                width: "100%",
                "& .MuiToggleButton-root": {
                  flex: 1,
                  color: "#6e3fc9",
                  "&.Mui-selected, &.Mui-selected:hover": {
                    backgroundColor: "#e2d9f7 !important",
                    color: "#4a2b8a !important",
                    fontWeight: "bold",
                  },

                  "&:hover": {
                    backgroundColor: "#f2ecfc !important",
                    color: "#6e3fc9",
                  },
                },
              }}
            >
              <ToggleButton value="fee-based">Paid Users</ToggleButton>
              <ToggleButton value="complimentary">
                Complimentary Users
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <GenericTable
            height={420}
            columns={userColumns}
            data={users}
            isLoading={isLoading}
            page={page}
            totalPages={pagination?.totalPages || 1}
            onPageChange={(page) => handlePageChange(page)}
            headerBgColor="#6e3fc9"
          />
        </div>
      </section>
    </>
  );
};

export default PortalUsageReport;
